// https://github.com/alphagov/govuk-frontend/tree/master/src/components/select

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BLACK, ERROR_COLOUR, YELLOW } from 'govuk-colours';
import { MEDIA_QUERIES } from '@govuk-react/constants';
import { typography } from '@govuk-react/lib';
import theme from '../theme';

import ErrorText from '@govuk-react/error-text';
import HintText from '@govuk-react/hint-text';

const Label = styled.div`
   margin: ${({margin}) => margin ? margin : "30px 0px"}};
`

const LabelText = styled.h4`
  font-size: ${theme.typography.body.fontSize};
  font-weight: 700;
  margin-top: 0px;
  margin-bottom: 10px
`


export const SelectOptions = ({items}) => {
  const options = items.map((item) => {
    return <option>{item}</option>
  })
  options.unshift(<option hidden/>)
  return options
}

const StyledSelect = styled('select')(
  typography.font({ size: 19 }),
  {
    boxSizing: 'border-box',
    width: '100%',
    height: '33px',
    padding: '5px 4px 4px',
    border: `2px solid #0b0c0c`,
    [MEDIA_QUERIES.LARGESCREEN]: {
      width: '50%',
      height: '38px',
    },
    ':focus': {
      outline: `3px solid ${YELLOW}`,
      outlineOffset: 0,
    },
  },
  ({ error }) => ({
    border: error ? `4px solid ${ERROR_COLOUR}` : undefined,
  })
);

export const Select = ({ children, hint, label, meta, input, ...props }) => (
  <Label {...props} error={meta.touched && meta.error}>
    <LabelText>{label}</LabelText>
    {hint && <HintText>{hint}</HintText>}
    {meta.touched && meta.error && <ErrorText>{meta.error}</ErrorText>}
    <StyledSelect error={meta.touched && meta.error} {...input}>
      {children}
    </StyledSelect>
  </Label>
);

Select.defaultProps = {
  hint: undefined,
  errorText: undefined,
  input: {},
  meta: {},
};

Select.propTypes = {
  hint: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any,
  }),
  meta: PropTypes.shape({
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    dirtySinceLastSubmit: PropTypes.bool,
    error: PropTypes.any,
    initial: PropTypes.any,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitError: PropTypes.any,
    submitFailed: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool,
  }),
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  errorText: PropTypes.string,
};

export { StyledSelect as SelectInput };
